import React from "react";
import { useWindowDimensions } from "@app/hooks";
import { View } from "@/styles/reactnative";
import HeaderBottomLists from "./HeaderBottomLists";
import { useBalance } from "../../../../hooks/user/mybalance";
import BigNumber from "bignumber.js";
import { SETTING_TYPE_SYSTEM } from "../../../../constants/SETTING";
import { getSetting, useSetting } from "../../../../hooks/user/mysetting";
import { useFetcherPublic } from "../../../../hooks/fetcher";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";

const AssetSpotHeaderBottom = () => {
  const isMobile = useIsMobile();

  const { data: spot } = useBalance("USDT", 0);

  const balance = BigNumber(spot?.balance);

  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const settingCurrency = getSetting(setting, "CURRENCY", "USD");

  const currencyList = useFetcherPublic("/system/currency");
  const equiv = currencyList?.data?.result?.result?.find(
    (item: any) => item.code === settingCurrency
  );

  const equivValue = BigNumber(balance || 0)
    .multipliedBy(equiv?.price || 1)
    .toNumber();

  const data = [
    {
      title: "totalEquity",
      usd: spot?.balance,
      currency: settingCurrency,
      currencyValue: equivValue,
    },
    // {
    //   title: "netEquity",
    //   usd: spot?.balance,
    //   currency: settingCurrency,
    //   currencyValue: equivValue,
    // },
    // {
    //   title: "totalLiability",
    //   usd: "0.00",
    //   currency: settingCurrency,
    //   currencyValue: 0,
    // },
  ];

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        height: "70%",
        marginTop: isMobile ? MobileCalVW(30) : undefined
      }}
    >
      {data.map((item, index) => (
        <HeaderBottomLists key={index.toString()} item={item} index={index} />
      ))}
    </View>
  );
};

export default React.memo(AssetSpotHeaderBottom);
